import { LabelContent } from 'V2Components'
import { getResourceName, getRsrcIcon } from 'features/resources'
import { Label, Typography } from 'procyon-ui'
import React from 'react'
import { MeshClusterLabelContent } from '../MeshClusterLabelContent'
import useAppView from 'Core/Hooks/useAppView'
import { getHTMLDataTestID } from 'infra/utils'

const KubeCluster = ({ rsrc, account }) => {
  const { appView } = useAppView()
  const AccountIcon = getRsrcIcon(account)

  const getAccountName = (rsrc) => {
    return rsrc?.Spec?.CloudType === 'PRIVATE' ? 'Private' : getResourceName(account)
  }

  return (
    <div>
      <LabelContent
        data-testid={'name'}
        dataTestId={getHTMLDataTestID('kube-cluster', 'label', 'name')}
        title='Name'
        content={getResourceName(rsrc)}
      />
      <LabelContent
        data-testid={'account'}
        title='Account'
        dataTestId={getHTMLDataTestID('kube-cluster', 'label', 'account')}
        content={
          <div className='flex gap-2 items-center'>
            {AccountIcon && <AccountIcon className='mr-2' />}
            <Typography variant='body-regular'>{getAccountName(rsrc)}</Typography>
          </div>
        }
      />
      <LabelContent
        data-testid={'cluster-endpoint'}
        dataTestId={getHTMLDataTestID('kube-cluster', 'label', 'cluster-endpoint')}
        title='Cluster Endpoint'
        content={rsrc.Spec.ClusterEndpoint}
      />
      <LabelContent
        data-testid={'iamres'}
        dataTestId={getHTMLDataTestID('kube-cluster', 'label', 'iam-res')}
        title='IAM Res'
        content={rsrc.Spec.IAMRes}
      />
      <LabelContent
        data-testid={'dns-name'}
        dataTestId={getHTMLDataTestID('kube-cluster', 'label', 'dns-names')}
        title='DNS Names'
        content={rsrc.Spec.DNSNames.Elems.join(', ')}
      />
      {appView === 'admin' ? (
        <MeshClusterLabelContent rsrc={rsrc} />
      ) : (
        <LabelContent
          data-testid={'cluster'}
          dataTestId={getHTMLDataTestID('kube-cluster', 'label', 'cluster')}
          title='Cluster'
          content={rsrc.Spec.MeshCluster}
        />
      )}
    </div>
  )
}

export { KubeCluster }
